<template>
	<div class="user-index">
		user+++++++
	</div>
</template>
<script>
	export default {};
</script>
<style lang="less">
.user-index {
	width: 100%;
	height: 100%;
}
</style>